import * as D from '@docmaps/sdk';
import * as TE from 'fp-ts/lib/TaskEither';
import * as A from 'fp-ts/lib/Array';
import { pipe } from 'fp-ts/lib/function';
import { stepArrayToDocmap, mapLeftToUnknownError } from './utils';
export function stepsForIdRecursive(plugin, id, visitedIds, annotations) {
    const program = pipe(TE.Do, TE.bind('isrForId', () => {
        return pipe(id, plugin.stepForId, TE.map((isr) => ({
            ...isr,
            step: {
                ...isr.step,
                actions: isr.step.actions.map((a) => ({
                    ...a,
                    inputs: annotations.inputs,
                })),
            },
        })));
    }), TE.bind('initialChain', ({ isrForId }) => TE.of({
        head: isrForId.step,
        all: [isrForId.step],
        visitedIds: visitedIds.add(id),
    })), TE.bind('prefixChain', ({ isrForId, initialChain }) => pipe(isrForId.preprints, A.filter((preprintId) => !initialChain.visitedIds.has(preprintId)), TE.traverseSeqArray((preprintId) => {
        return stepsForIdRecursive(plugin, preprintId, initialChain.visitedIds, {
            inputs: [],
        });
    }), TE.map((meta) => {
        const newStep = {
            ...initialChain.head,
            actions: initialChain.head.actions.map((a) => ({
                ...a,
                inputs: meta.reduce((memo, c) => memo.concat(c.head.actions.reduce((m, a) => m.concat(a.outputs), [])), a.inputs),
            })),
        };
        return {
            head: newStep,
            all: meta.reduce((m, c) => m.concat(c.all), []).concat([newStep]),
            visitedIds: meta.reduce((m, c) => new Set([...m, ...c.visitedIds]), initialChain.visitedIds),
        };
    }))), TE.bind('postfixChain', ({ isrForId, initialChain, prefixChain }) => {
        if (isrForId.reviews.length == 0) {
            return TE.of(prefixChain);
        }
        return pipe(isrForId.reviews, TE.traverseSeqArray((rId) => plugin.actionForReviewId(rId)), TE.map((listOfActions) => ({
            actions: listOfActions.map((a) => ({
                ...a,
                inputs: initialChain.head.actions.reduce((m, a) => m.concat(a.outputs), []),
            })),
            assertions: [
                {
                    status: 'reviewed',
                    item: String(id),
                },
            ],
        })), TE.chainEitherK((rs) => pipe(rs, D.Step.decode, mapLeftToUnknownError('decoding step'))), TE.map((reviewStep) => ({
            head: prefixChain.head,
            all: prefixChain.all.concat([reviewStep]),
            visitedIds: new Set([...prefixChain.visitedIds, ...isrForId.reviews]),
        })));
    }), TE.bind('completeChain', ({ isrForId, postfixChain }) => {
        return pipe(isrForId.manuscripts, A.filter((manId) => !postfixChain.visitedIds.has(manId)), TE.traverseArray((manId) => {
            return stepsForIdRecursive(plugin, manId, postfixChain.visitedIds, {
                inputs: postfixChain.head.actions.reduce((m, a) => m.concat(a.outputs), []),
            });
        }), TE.map((meta) => {
            return {
                head: postfixChain.head,
                all: postfixChain.all.concat(meta.reduce((m, c) => m.concat(c.all), [])),
                visitedIds: meta.reduce((m, c) => new Set([...m, ...c.visitedIds]), postfixChain.visitedIds),
            };
        }));
    }), TE.map(({ completeChain }) => completeChain));
    return program;
}
export async function process(plug, publisher, id) {
    const program = pipe(id, () => stepsForIdRecursive(plug, id, new Set(), { inputs: [] }), TE.chainEitherK((steps) => stepArrayToDocmap(publisher, id, steps.all)));
    return await program();
}
//# sourceMappingURL=processor.js.map